export const formatYYYYMMDD = 'DD/MM/YYYY';
// export const formatYYYYMMDD_HHMMSS = 'HH:mm:ss YYYY-MM-DD';
export const formatYYYYMMDD_HHMMSS = 'DD/MM/YYYY HH:mm:ss';
export const formatYYYYMMDD_HHMM = 'DD/MM/YYYY HH:mm';

export const LanguageEnum = {
    zhCN: 'zh-CN',
    en: 'en',
    ko: 'ko',
    es: 'es',
    de: 'de',
    pt: 'pt'
};

export const SkinImageFile = {
    black: 'image',
    white: 'white-image',
    blue: 'blue-image'
};

// 股票数值精度小数点
export const StockPrecision = 4;
// 默认语言
export const defaultLang = 'fr';

export const StockTypeCoin = {
    1: 'USD',
    2: 'HKD',
    3: 'KRW'
};

export const StockTypeSimple = {
    1: 'US',
    2: 'HK',
    3: 'KS'
};
// 默认货币
export const defaultCoin = 'USDC';
